import { Request } from 'api';
import { AxiosResponse } from 'axios';

interface DeleteResponse {
    success: boolean;
    message: string;
}

type ReturnType = Promise<AxiosResponse<DeleteResponse>>;

const deleteTrackEvent = (uuid: string): ReturnType => {
    return Request.delete(`/workouts/track-events/${uuid}`);
};

export default deleteTrackEvent;
